import React from "react";
import { Link, useLocation } from "react-router-dom";
import { FiCheck, FiMail, FiPackage } from "react-icons/fi";
import { formatPrice } from "../config/siteConfig";
import "../css/paysuccess.css";

const PaySuccess = () => {
  const { state } = useLocation();
  const orderNumber = state?.orderNumber || "PW-DEMO";

  return (
    <main className="success-page">
      <section className="success-card">
        <div className="success-check"><FiCheck /></div>
        <p className="eyebrow">Order received</p>
        <h1>Thank you for your order.</h1>
        <p className="success-intro">Your paper goods are reserved and will soon be packed with care. This demo has not charged a real payment method.</p>
        <div className="success-order-number"><span>Order number</span><strong>{orderNumber}</strong></div>
        {state?.total != null && <div className="success-order-number"><span>Order total</span><strong>{formatPrice(state.total)}</strong></div>}
        <div className="success-steps">
          <article><FiMail /><div><h2>Confirmation</h2><p>We sent order details to {state?.email || "the email supplied at checkout"}.</p></div></article>
          <article><FiPackage /><div><h2>What happens next</h2><p>You’ll receive another note when the parcel is ready to begin its journey.</p></div></article>
        </div>
        <div className="success-actions"><Link className="button" to="/shop">Keep exploring</Link><Link className="button button--outline" to="/contact">Contact us</Link></div>
      </section>
    </main>
  );
};

export default PaySuccess;
